import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-family: 'Roboto', sans-serif;
  font-size: 42px;
  font-style: italic;
  font-weight: 900;
`;
Container.displayName = 'Container';

export const Image = styled.img`
  height: 92px;
  margin-top: 5px;
  z-index: 2;
`;
Image.displayName = 'Image';

export const Logo = styled.img`
  margin-top: 5px;
`;
Logo.displayName = 'Logo';

export const Points = styled.div`
  font-size: 56px;
  margin: 5px 4px 0;
  min-width: 45px;
  text-align: center;
`;
Points.displayName = 'Points';

export const SpaceBar = styled.div`
  background: linear-gradient(90deg, #d0a664 0%, #e47433 49.48%, #d0a664 100%);
  height: 8px;
  width: 100%;
`;
SpaceBar.displayName = 'SpaceBar';

export const TeamsContainer = styled.div`
  align-items: center;
  background: linear-gradient(90deg, #242d25 0%, #000000 49.48%, #242d25 100%);
  color: #ffffff;
  display: flex;
  height: 60px;
  padding: 0 16px;
`;
TeamsContainer.displayName = 'TeamsContainer';

export const TeamName = styled.span`
  margin: 5px 20px 0;
  min-width: 120px;
  text-align: center;
`;
TeamName.displayName = 'TeamName';

export const TimerContainer = styled.div`
  align-items: center;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0) 0%,
    #000000 31.77%,
    #000000 69.79%,
    rgba(0, 0, 0, 0) 100%
  );
  display: flex;
  height: 43px;
  justify-content: center;
  width: 223px;
`;
TimerContainer.displayName = 'TimerContainer';

export const Timer = styled.div`
  color: #ffffff;
  font-size: 38px;
  letter-spacing: 0.03em;
  min-width: 120px;
  text-align: center;
`;
Timer.displayName = 'Timer';
